/* eslint-disable max-len */
import React, {FC} from "react"

import id from "@irati/utils/id"

import BaseSvgIcon from "./Base"

interface Props {
  id?: string
  title?: string
}

const SummaryTrophies: FC<Props> = ({id: _id = "summary-trophy-icon", title = "Trophies", ...rest}) => {
  const props = {id: _id, title, ...rest}
  const titleId = id("title", props)

  return (
    <BaseSvgIcon {...rest} aria-labelledby={titleId}>
      <path
        d="m9 12.0091434-4.42182534 3.076977 1.55995986-5.15624394-4.29279821-3.25456761 5.38593356-.10975703 1.76873013-5.08841042 1.7687301 5.08841042 5.3859336.10975703-4.2927982 3.25456761 1.5599598 5.15624394z"
        fill="#26b4ae"
        stroke="#3d3d36"
      />
    </BaseSvgIcon>
  )
}

export default SummaryTrophies
